import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import MediaQuery, { breakpoints } from 'utils/media-query';
import ActivityIcon from 'components/ActivityIcon';
import CTA from '../CTA';
import { useActivityPublicContext } from '../../ActivityPublicContext';

import styles from './styles.scss';

const ActivityCard = ({ activity }) => {
  const activityType = activity.type.toLowerCase();
  const translatedActivityType = I18n.t(
    `strava.activities.types_v2.${activityType}`
  );

  const { track } = useActivityPublicContext();

  return (
    <a
      href={`/activities/${activity.id}`}
      className={styles.activity}
      onClick={() =>
        track({
          element: `view_this_${activityType}`,
          action: 'click'
        })
      }
    >
      <div className={styles.activityImage}>
        <img src={activity.image.src} alt={activity.image.alt} />
      </div>

      <div className={styles.activityDetails}>
        <div className={styles.activityHeader}>
          <time dateTime={activity.start_date_local} className={styles.time}>
            {activity.start_date_local}
          </time>
        </div>

        <div className={styles.activityBody}>
          <h4 className={styles.activityTitle}>{activity.name}</h4>
          <div className={styles.activityIconContainer}>
            <div className={`app-icon-wrapper ${styles.activityIcon}`}>
              <ActivityIcon
                type={activity.detailed_type}
                size="small"
                className={styles.activityIconImage}
                title={translatedActivityType}
              />
            </div>
          </div>
        </div>

        <div className={styles.activityFooter}>
          {I18n.t('strava.activities.show_public.view_this_activity', {
            activity_type: translatedActivityType
          })}
        </div>
      </div>
    </a>
  );
};

ActivityCard.propTypes = {
  activity: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    detailed_type: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    image: PropTypes.shape().isRequired,
    start_date_local: PropTypes.string.isRequired
  }).isRequired
};

const Upsell = () => {
  const { track } = useActivityPublicContext();
  return (
    <div className={styles.upsellContainer}>
      <h4>{I18n.t('strava.activities.show_public.see_more')}</h4>
      <CTA
        className={styles.upsellCta}
        modalVariant="generic"
        data-cy="sign-up-to-see-more-cta"
        onClick={() =>
          track({
            element: 'signup_to_see_more',
            action: 'click'
          })
        }
      >
        {/* TODO ADIEL replace this with 'sign_up' */}
        {I18n.t('strava.activities.show_public.signup_to_see_more')}
      </CTA>
    </div>
  );
};

const MoreActivities = ({ athlete, activities }) => {
  const { track } = useActivityPublicContext();
  return (
    <div className={styles.moreActivities}>
      <div className="container">
        <div className="row">
          <div className={`${styles.header} col-md-4`}>
            <h3 className={styles.title}>
              {I18n.t(
                'strava.activities.show_public.more_activities_from_athlete',
                { athlete_name: athlete.name }
              )}
            </h3>
            <CTA
              className={styles.headerCta}
              modalVariant="generic"
              data-cy="sign-up-to-see-more-cta"
              onClick={() =>
                track({ element: 'signup_to_see_more', action: 'click' })
              }
            >
              {/* TODO ADIEL replace this with 'sign_up' */}
              {I18n.t('strava.activities.show_public.signup_to_see_more')}
            </CTA>
          </div>

          <div className={`col-md-8 ${styles.body}`}>
            <ul className={styles.activitiesList}>
              {activities.map((activity) => (
                <li key={activity.id}>
                  <ActivityCard activity={activity} />
                </li>
              ))}

              <MediaQuery maxWidth={breakpoints.screenSm}>
                <li className={styles.upsell}>
                  <Upsell />
                </li>
              </MediaQuery>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

MoreActivities.propTypes = {
  athlete: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
  activities: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

export default MoreActivities;
